import React from "react";
import { Typography, Box, IconButton, Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import WarningIcon from "@material-ui/icons/Warning";
import EventNoteIcon from "@material-ui/icons/EventNote";
const useStyles = makeStyles((theme) => ({
  // Aviso
    cardContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderRadius: "15px",
    backgroundColor: '#e57373',
    color: theme.palette.warning.contrastText,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    marginBottom: theme.spacing(2),
    width:"350px",
    height:"200px"
  },
  avatar: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    marginRight: theme.spacing(2),
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  content: {
    flex: 1,
  },
  title: {
    fontWeight: 700,
    fontSize: "1.2rem",
    marginBottom: theme.spacing(1),
  },
  statContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
  statText: {
    fontWeight: 500,
    fontSize: "1rem",
  },
}));

const AvisoTareas = ({ tarjetas }) => {
  const classes = useStyles();
  return (
    <Box className={classes.cardContainer}>
      <Avatar className={classes.avatar}>
        <WarningIcon />
      </Avatar>
      <Box className={classes.content}>
        <Typography variant="h6" className={classes.title}>
          Tareas importantes
        </Typography>
        <Box className={classes.statContainer}>
          <Typography variant="body2" className={classes.statText}>
            {tarjetas?.por_vencer} Tareas por vencer
          </Typography>
          <Typography variant="body2" className={classes.statText}>
            {tarjetas?.pasadas} Tareas vencidas
          </Typography>
          <Typography variant="body2" className={classes.statText}>
            {tarjetas?.pendientes} Tareas pendientes
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AvisoTareas;
